import "../styles/footer.scss";
import image from "../assets/img/footerImg.png";
import logo from "../assets/img/logo.png";
import "../App.scss";
import phone from "../assets/img/phone.png";
import ig from "../assets/img/ig.png";
import fb from "../assets/img/fb.png";
import mail from "../assets/img/mail.png";
import { Data } from "../Location";
import { useEffect, useState } from "react";

export function Footer() {
    const [data, setData] = useState(null);
    useEffect(() => {
        Data().then((r) => {
            setData(r);
        });
    }, []);
    return (
        <div className="footer">
            <div className="footerMain">
                <div></div>
                <div></div>
                <div className="in">
                    <div className="m10"></div>
                    <img className="logo" src={logo} />
                    <div></div>
                    <div className="textSmall littleBox">
                        {data ? data.footer.title : ""}
                    </div>
                    <div className="phone">
                        <img className="phoneIcon" src={phone}></img>
                        <div className="phoneNumber">
                            <div>+976 89020369</div>
                            <div>+976 98670369</div>
                        </div>
                    </div>
                    <div className="icons">
                        <a href="mailto: graylingland4@gmail.com">
                            <img src={mail}></img>
                        </a>
                        <a href="https://www.instagram.com">
                            <img src={ig}></img>
                        </a>
                        <a href="https://www.facebook.com">
                            <img src={fb}></img>
                        </a>
                    </div>
                </div>
                <div className="navs">
                    <div
                        className="btn m20 textMedium bold"
                        onClick={() => {
                            window.location.href = "/";
                        }}
                    >
                        {data ? data.footer.main : ""}
                    </div>
                    <div
                        className="btn m20 textSmall"
                        onClick={() => {
                            window.location.href = "/#1";
                        }}
                    >
                        {data ? data.footer.services : ""}
                    </div>
                    <div
                        className="btn m20 textSmall"
                        onClick={() => {
                            window.location.href = "/#2";
                        }}
                    >
                        {data ? data.footer.top : ""}
                    </div>
                    <div
                        className="btn m20 textSmall"
                        onClick={() => {
                            window.location.href = "/#3";
                        }}
                    >
                        {data ? data.footer.sets : ""}
                    </div>
                    <div
                        className="btn m20 textSmall"
                        onClick={() => {
                            window.location.href = "/#4";
                        }}
                    >
                        {data ? data.footer.emotion : ""}
                    </div>
                    <div
                        className="btn m20 textSmall"
                        onClick={() => {
                            window.location.href = "/#QA";
                        }}
                    >
                        {data ? data.footer.qa : ""}
                    </div>
                </div>
                <div className="navs">
                    <div
                        className="btn m20 textMedium bold"
                        onClick={() => {
                            window.location.href = "/about";
                        }}
                    >
                        {data ? data.footer.about : ""}
                    </div>
                    <div
                        className="btn m20 textSmall"
                        onClick={() => {
                            window.location.href = "/about";
                        }}
                    >
                        {data ? data.footer.aboutm : ""}
                    </div>
                </div>
                <div className="navs">
                    <div
                        className="btn m20 textMedium bold"
                        onClick={() => {
                            window.location.href = "/archive";
                        }}
                    >
                        {data ? data.footer.tabi : ""}
                    </div>
                    <div
                        className="btn m20 textSmall"
                        onClick={() => {
                            window.location.href = "/archive";
                        }}
                    >
                        {data ? data.footer.aboutTabi : ""}
                    </div>
                </div>
                <div></div>
                <div></div>
            </div>
            <div className="textSmall textCenter copy">
                TravelAgent © 2024 All Right Reserved.
            </div>
            <img className="footImage" src={image} />
        </div>
    );
}
